import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  
  import { ActivatedRoute, Router } from '@angular/router';
  import { DatePipe } from '@angular/common';
  
  import { TalkService } from '../../services/talk.service';
  import { FolioPillComponent } from '../ui/folio-pill/folio-pill.component';
  
  @Component({
    selector: 'app-talk-detail',
    templateUrl: './talk-detail.html',
    styleUrl: './talk-detail.scss',
    imports: [DatePipe, FolioPillComponent],
  })
  export class TalkDetailComponent implements OnInit {
    private talkService = inject(TalkService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private cdr = inject(ChangeDetectorRef);
  
    talk: any = null;
    isLoading = true;
  
    ngOnInit(): void {
      const talkId = this.route.snapshot.paramMap.get('id');
  
      if (!talkId) {
        this.router.navigate(['/admin/talks']);
        return;
      }
  
      this.loadTalk(talkId);
    }
  
    loadTalk(id: string): void {
      this.isLoading = true;
  
      this.talkService.getTalk(id).subscribe({
        next: (response: any) => {
          console.log('🟢 PLÁTICA RECIBIDA:', response);
  
          this.talk = response.data.document;
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
  
        error: (error) => {
          console.error(
            '🔴 ERROR CARGANDO PLÁTICA:',
            error,
          );
  
          this.talk = null;
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
      });
    }
  
    goBack(): void {
      this.router.navigate(['/admin/talks']);
    }
  }